var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"align":"center"}},[_c('img',{staticClass:"spinner-logo img-buton-overlay mt-2",class:_vm.clase,attrs:{"opacity":"0.6","src":require("../../../assets/images/login/master_isotipo_VP.svg"),"alt":"logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }